import { v4 as uuidv4 } from 'uuid';
import { types } from '../actions/constFromApi';

const initialState = {
  functionsDirections: [],
  industries: [],
  contractTypes: [],
  filterPeriods: []
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_CONSTATNTS_FULFILLED:
      return {
        ...state,
        functionsDirections: [
          { label: 'Function', value: '', key: uuidv4(10) },
          ...action.payload.functionsDirections.map((func) => ({
            label: func.Name,
            value: func.Name,
            key: func.Id,
            JobFunctionId: func.Id
          }))
        ],
        industries: [
          { label: 'Industry', value: '', key: uuidv4(10) },
          ...action.payload.industries.map((industry) => ({
            label: industry.Name,
            value: industry.Name,
            key: industry.Id,
            IndustryId: industry.Id
          }))
        ],
        contractTypes: [
          { label: 'Contract Type', value: '', key: uuidv4(10) },
          ...action.payload.contractTypes.map((type) => ({
            label: type.TypesName,
            value: type.TypesName?.toLowerCase(),
            key: type.Id
          }))
        ],
        filterPeriods: [
          { label: 'Date Posted', value: '', key: uuidv4(10) },
          ...action.payload.filterPeriods.map((period) => ({
            label: period.DatePosted,
            value: period.Value,
            key: period.Id
          }))
        ]
      };
    default:
      return state;
  }
}
